import React from 'react';
import { TextVariant } from '@naf/text';
import { Logo } from '../LogoDecorations/Logo';
import * as S from './LogoArea.styles';

const LogoArea = ({ onNavClick }: { onNavClick: () => void }) => (
  <S.LogoArea>
    <Logo onNavClick={onNavClick} />
    <S.RoadAssistance href="tel:+47-08505">
      <S.StyledTopText tag="span" variant={TextVariant.Small}>
        Ring oss{' '}
      </S.StyledTopText>
      <S.StyledBottomText tag="span" variant={TextVariant.Small}>
        08 505
      </S.StyledBottomText>
    </S.RoadAssistance>
    <S.SeparatorLine />
  </S.LogoArea>
);

export default LogoArea;
